/**
 * Stable CSS class names for E2E — StoreReturnSearch page.
 * Used by the test automation team as deterministic selectors.
 * Containers use `store-return-search__<element>`; inputs and
 * user-interactable controls use `store-return-search-input--<name>`.
 */
export const SRS = {
    page: 'store-return-search-page',
    root: 'store-return-search',

    header: 'store-return-search__header',
    headerIcon: 'store-return-search__header-icon',
    headerTitle: 'store-return-search__header-title',

    loading: 'store-return-search__loading',

    barcodeDialog: 'store-return-search__barcode-dialog',
    barcodeDialogTitle: 'store-return-search__barcode-dialog-title',
    barcodeDialogTitleIcon: 'store-return-search__barcode-dialog-title-icon',
    barcodeDialogTitleText: 'store-return-search__barcode-dialog-title-text',
    barcodeDialogCloseIcon: 'store-return-search__barcode-dialog-close-icon',
    barcodeDialogContent: 'store-return-search__barcode-dialog-content',
    barcodeDialogList: 'store-return-search__barcode-dialog-list',
    barcodeDialogChip: 'store-return-search__barcode-dialog-chip',
    barcodeDialogActions: 'store-return-search__barcode-dialog-actions',
    btnDialogClose: 'store-return-search-input--button-dialog-close',

    filterBar: 'store-return-search__filter-bar',
    filterGrid: 'store-return-search__filter-grid',
    filterReturnCode: 'store-return-search__filter-return-code',
    filterStoreCode: 'store-return-search__filter-store-code',
    filterDateRange: 'store-return-search__filter-date-range',
    filterStatus: 'store-return-search__filter-status',
    filterLocation: 'store-return-search__filter-location',
    filterAction: 'store-return-search__filter-action',

    inputReturnCode: 'store-return-search-input--return-code',
    inputStoreCode: 'store-return-search-input--store-code',
    inputDateRange: 'store-return-search-input--date-range',
    inputStatus: 'store-return-search-input--status',
    inputLocation: 'store-return-search-input--location',
    btnFilter: 'store-return-search-input--button-filter',

    /** Individual menu items inside the status / location selects. */
    statusMenuItem: 'store-return-search__status-menu-item',
    statusMenuCheckbox: 'store-return-search-input--status-checkbox',
    statusMenuLabel: 'store-return-search__status-menu-label',
    locationMenuItem: 'store-return-search__location-menu-item',

    grid: 'store-return-search__grid',

    cellDate: 'store-return-search__cell-date',
    cellDateDay: 'store-return-search__cell-date-day',
    cellDateTime: 'store-return-search__cell-date-time',
    cellDateEmpty: 'store-return-search__cell-date-empty',

    cellReturnId: 'store-return-search__cell-return-id',
    cellReturnNo: 'store-return-search__cell-return-no',
    /** Clickable link inside the return-no cell. */
    cellReturnNoLink: 'store-return-search-input--cell-return-no-link',

    cellOrderId: 'store-return-search__cell-order-id',
    cellOrderNo: 'store-return-search__cell-order-no',
    /** Clickable link inside the order-no cell. */
    cellOrderNoLink: 'store-return-search-input--cell-order-no-link',

    cellCity: 'store-return-search__cell-city',
    cellStatus: 'store-return-search__cell-status',
    cellStatusChip: 'store-return-search__cell-status-chip',
    cellOperator: 'store-return-search__cell-operator',

    cellBarcode: 'store-return-search__cell-barcode',
    /** Clickable barcode cell that opens the dialog. */
    cellBarcodeOpen: 'store-return-search-input--cell-barcode-open',
    cellBarcodeItem: 'store-return-search__cell-barcode-item',
    cellBarcodeMore: 'store-return-search__cell-barcode-more',
    cellBarcodeEmpty: 'store-return-search__cell-barcode-empty',

    cellStoreCode: 'store-return-search__cell-store-code',
} as const;

export const srsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
